import React, { useMemo } from 'react';
import { CSVLink } from 'react-csv';
import cn from 'classnames';

import { beTransactionPayoutRead } from 'actions/transaction/beTransactionPayout.action';
import Button from 'components/form/Button.component';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import { usePrepareReadOnly } from 'hooks/usePrepare.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './PayoutLog.module.scss';

const PayoutLog = ({ bgn, end }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { data, isLoading } = usePrepareReadOnly(beTransactionPayoutRead, { bgn, end });
  const csvData = data?.text;
  const fileName = useMemo(() => `${bgn} - ${end}.csv`, [bgn, end]);

  return (
    <div
      data-bem="PayoutLog"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {t('businessReports.downloadableReports.splitTakingsLogDateRange', {
        fromDate: bgn,
        toDate: end,
      })}
      {isLoading || !data ? (
        <InlineSpinner variant="small" />
      ) : (
        <CSVLink data={csvData} filename={fileName}>
          <Button variant="primary" onClick={alwaysNoop}>
            {t('businessReports.downloadableReports.downloadSplitTakingsLogButton')}
          </Button>
        </CSVLink>
      )}
    </div>
  );
};

export default PayoutLog;
